<template>

  <div>


    <app-header />


    <div class="container">

		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id">{{ project.name }}</router-link></li>
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id+'/tables'">{{ _lang('Collections') }}</router-link></li>
				<li class="breadcrumb-item active" aria-current="page">{{table.name}}</li>
				<li class="breadcrumb-item active" aria-current="page">{{ _lang('Edit') }}</li>
			</ol>
		</nav>



      <form method="post" @submit.prevent="onSubmit">

        <div class="form-group">
          <label>{{ _lang('Name') }}</label>
          <input v-model="table.name" type="text" class="form-control" required>
        </div>

        <div class="form-group">
          <label>{{ _lang('Plural name') }}</label>
          <input v-model="table.meta.plural" type="text" class="form-control" required>
        </div>

        <div class="form-group">
          <label>{{ _lang('Singular name') }}</label>
          <input v-model="table.meta.singular" type="text" class="form-control" required>
        </div>

        <div class="form-group">
          <label>{{ _lang('Slug') }}</label>
          <input v-model="table.slug" type="text" class="form-control">
        </div>

        <div class="form-group">
          <label><input v-model="table.meta.hasSingular" type="checkbox"> {{ _lang('Has singular page') }}</label>
        </div>
        <div class="form-group">
          <label><input v-model="table.meta.includeDate" type="checkbox" > {{ _lang('Include date field') }}</label>
        </div>
        <div class="form-group">
          <label><input v-model="table.meta.includeTitle" type="checkbox" > {{ _lang('Include name field') }}</label>
        </div>


				<div class="form-group" v-if="id">
					<label>{{ _lang('Ordering') }}</label>
					<div class="d-flex mb-2" style="align-items:center">
						<span>#1</span>
						<select v-model="table.meta.orderField" class="form-control" required>
							<option></option>
							<option value="created_at">{{ _lang('Date') }}</option>
							<option value="name">{{ _lang('Name') }}</option>
							<option v-for="field in table.fields" :value="field.slug">{{field.name}}</option>
						</select>
						<select v-model="table.meta.orderDir" class="form-control col-2 ml-2" required>
							<option value="asc">{{ _lang('Ascending') }}</option>
							<option value="desc">{{ _lang('Descending') }}</option>
						</select>
						<span class="btn" @click="$set(table.meta,'orderField2','')">+</span>
					</div>
					<div v-if="table.meta.orderField2!==undefined" class="d-flex mb-2" style="align-items:center">
						<span>#2</span>
						<select v-model="table.meta.orderField2" class="form-control" required>
							<option></option>
							<option value="created_at">{{ _lang('Date') }}</option>
							<option value="name">{{ _lang('Name') }}</option>
							<option v-for="field in table.fields" :value="field.slug">{{field.name}}</option>
						</select>
						<select v-model="table.meta.orderDir2" class="form-control col-2 ml-2" required>
							<option value="asc">{{ _lang('Ascending') }}</option>
							<option value="desc">{{ _lang('Descending') }}</option>
						</select>
						<span class="btn" @click="$delete(table.meta,'orderField2')">x</span>
					</div>
				</div>



        <button type="submit" class="btn btn-primary">{{ _lang('Save') }}</button>
       <span class="btn btn-light" @click="goBack">{{ _lang('Back') }}</span>
        <span v-if="table.id" class="btn btn-danger" @click="deleteTable(table.id)">{{ _lang('Delete') }}</span>

      </form>

    </div>
  </div>


</template>
<script>

  import componentFunctions from '../mixin.components.js'
  import axios from 'axios';
  import appHeader from '../components/appHeader.vue'

  export default {
    props:['project_id','id'],
    mixins:[componentFunctions],
    components:{
      appHeader,
    },
    data() {
      return {
        table:{
          name:'',
          slug:'',
          meta:{
						hasSingular:true,
						includeDate:true,
						includeTitle:true,
						orderField:'created_at',
						orderDir:'desc',
					}
        },
      }
		},
		computed:{
			project(){
					return this.$store.getters.project;
			}
		},
    methods:{
      goBack(){
        this.$router.go(-1);
        this.$router.push({ name: 'project-tables', params: { project_id:this.project_id} })
      },
      onSubmit(){

        let project_id = this.project_id;

        let data = {
            project_id,
            ...this.table,
        }

        axios({
          method: 'post',
          url: '/api/tables'+(this.id?'/'+this.id:''),
          data: data
        }).then((res) => {
					this.$store.dispatch('getProject',project_id)
          this.$router.push('/project/'+project_id+'/tables');
        });

			},
			deleteTable(table_id){
				if(!confirm(this._lang('Delete table and all posts?'))) return;
				axios({
						method: 'Delete',
						url: '/api/tables/'+table_id,
					}).then((res) => {
						this.$store.dispatch('getProject', this.project_id);
						this.$router.push('/project/'+ this.project_id+'/tables');
					});
			},

    },
    mounted(){
        if(this.id){
            axios({
                method: 'get',
                url: '/api/tables/'+this.id,
                }).then((res) => {
                    if(!res.data.meta){
                        res.data.meta = {}
                }
                this.table = res.data;
            });
        }
    }

  }



</script>

